tipoEsfera = function (e){

    let valor = e.value;
    if(e.value)
        $(".esfera").each(function(e){
            $(this).html($(this).html().replace('-',''));
            $(this).html($(this).html().replace('+',''));
            $(this).html(valor+$(this).html());
        })
}

tipoValor = function (e){
    let valor = e.value;
    let tipo = valor==='-' ? 'cilindro' :'adicion';
    if(e.value){
        $(".valor_adicion").addClass('d-none');
        $(".valor_cilindro").addClass('d-none');
        if(e.value==='+'){
            $("#th_tipo_valor").html("ADICIÓN");
            $("#th_tipo_valor").attr("colspan",50);
            $(".tipo_valor").attr("colspan",2);

        }
        else{
            $("#th_tipo_valor").html("CILINDRO");
            $("#th_tipo_valor").attr("colspan",25);
            $(".tipo_valor").attr("colspan",1);
        }

        $(".tdinput").addClass('d-none');
        $(".valor_"+tipo).removeClass('d-none');
        $(".tipo_valor").each(function(e){
            $(this).html($(this).html().replace('-',''));
            $(this).html($(this).html().replace('+',''));
            $(this).html(valor+$(this).html());
        })

    }
}

tipoValorSemiterminada = function (e){
    let valor = e.value;
    if(e.value){
        $(".tipo_adicion").addClass('d-none');
        $(".tipo_monofocal").addClass('d-none');

        if(e.value==='adicion'){
            $("#th_tipo_valor").html("ADICIÓN");
            $("#th_tipo_valor").attr("colspan",20);
            $(".tipo_valor").attr("colspan",2);
        }
        else{
            $("#th_tipo_valor").html("CANTIDAD");
            $("#th_tipo_valor").attr("colspan",10);
            $(".tipo_valor").attr("colspan",1);
        }

        //$(".tdinput").addClass('d-none');
        $(".tipo_"+valor).removeClass('d-none');

    }
}

$('#nombre_mica').autoComplete({
    noResultsText: "Sin resultados",
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/micaAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
});

if(document.getElementById('tipo_esfera')){
    $("#tipo_esfera").trigger('change');
}
if(document.getElementById('tipo_valor')){
    $("#tipo_valor").trigger('change');
}

eliminarMica = function(e){
    var data = e.dataset;
    $("#form_eliminar_mica")[0].reset();
    $("#eliminar_mica_id").val(data.id);
    $("#eliminar_mica_nombre").html(`¿Deseas eliminar la mica <strong>${data.nombre}</strong>?`);
}
eliminarMicaSemiterminada = function(e){
    var data = e.dataset;
    $("#form_eliminar_mica_semiterminada")[0].reset();
    $("#eliminar_mica_semiterminada_id").val(data.id);
    $("#eliminar_mica_semiterminada_nombre").html(`¿Deseas eliminar la mica semiterminada <strong>${data.nombre}</strong>?`);
}
eliminarMicaEspecial = function(e){
    var data = e.dataset;
    $("#form_eliminar_mica_especial")[0].reset();
    $("#eliminar_mica_especial_id").val(data.id);
    $("#eliminar_mica_especial_nombre").html(`¿Deseas eliminar la mica especial <strong>${data.nombre}</strong>?`);
}